function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M204.707 8.70711C205.098 8.31658 205.098 7.68342 204.707 7.29289L198.343 0.928932C197.953 0.538408 197.32 0.538408 196.929 0.928932C196.539 1.31946 196.539 1.95262 196.929 2.34315L202.586 8L196.929 13.6569C196.539 14.0474 196.539 14.6805 196.929 15.0711C197.32 15.4616 197.953 15.4616 198.343 15.0711L204.707 8.70711ZM2 184C2 115.781 27.1258 72.1054 64.8274 45.4414C102.588 18.7355 153.1 9 204 9V7C152.9 7 101.912 16.7645 63.6726 43.8086C25.3742 70.8946 0 115.219 0 184H2Z",
  fill: "#4A69FF"
});

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 184,
    viewBox: "0 0 205 184",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.9f0b5b2c.svg";
export { ForwardRef as ReactComponent };